export default __webpack_public_path__ + "static/media/cat-image-3.084e290f.png";